import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import classes from "./About.module.scss";
import classInput from "../../components/UI/Input/Input.module.scss";
import ReactGa from "react-ga";
import { gaTracker } from "../../helper/Helper";
import BrandCard from "./Brands/BrandCard";
import { Helmet } from "react-helmet";
import { HomeBreadcrumb } from "../../components/UI/HomeButton";
import { toast, ToastContainer } from "react-toastify";
import Input from "../../components/UI/Input/Input";
// Using reCAPTCHA v3: will load grecaptcha dynamically and execute on submit
import Button from "../../components/UI/Button/Button";
import JIcon from "../../components/UI/Icon/JIcon";
import scrollToComponent from "react-scroll-to-component";
import HeaderHero from "./HeaderHero/HeaderHero";
import { LANG_EN, REGEX_EMAIL_PATTERN } from "../../constants";
import { FormattedMessage } from "react-intl";
import { Context } from "../../context/Wrapper";
//import {FETCH_INIT_DATA, IS_LOADING} from "../../constants";

const [paramCategory, paramAction, paramLabel] = [
  "PageLoad",
  "About Us Page",
  "About JBFS",
];
const [paramSubmitCategory, paramSubmitAction, paramSubmitLabel] = [
  "Button",
  "About Us Submission",
  "Send Email from About JBFS Page",
];

// const initialState = {}
// const reducer = (type, action) => {
//     switch (action.type) {
//         case FETCH_INIT_DATA:
//             return {}
//         case IS_LOADING:
//             return {}
//     }
// }

const AboutHook = (props) => {
  const context = useContext(Context);

  // const [sstate, dispatch] = useReducer(reducer, initialState)
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState();
  const [settings, setSettings] = useState([]);
  const [options] = useState([
    { displayValue: "Talk with our chef", value: "TALK_WITH" },
    { displayValue: "Product Info", value: "PRODUCT_INFO" },
  ]);
  const [optionsId] = useState([
    { displayValue: "Bicara dengan chef kami", value: "TALK_WITH" },
    { displayValue: "Informasi Produk", value: "PRODUCT_INFO" },
  ]);
  const [isVerified, setIsVerified] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [isReadyToSend, setIsReadyToSend] = useState(false);
  const [state, setState] = useState({
    about: [],
    product_brands: [],
    modalToggle: false,
    // , name: '', phone_number: '', email: '', subject: 'TALK_WITH', message: '', subjectDesc: 'Talk with our chef'
    showUnder: false,
    done_about: false,
    done_brand: false,
    // , isVerified: false
    isValidemail: false,
    hasErrorname: false,
    hasErrorphone_number: false,
    hasErroremail: false,
    hasErroremailFormat: false,
    hasErrormessage: false,
  });
  const [defaultMessage] = useState([
    {
      displayId: "Saya mau tanya mengenai...",
      display: "Can you help me with...",
    },
  ]);

  useEffect(() => {
    //====================================================================
    // console.log('useEffect 1');
    //====================================================================
    ReactGa.pageview(
      window.location.origin.toString() + props.location.pathname
    );
    const loadDocumentTitle = () => {
      document.title = "About Japfa";
    };
    window.scrollTo(0, 0);
    gaTracker(paramCategory, paramAction, paramLabel);

    const ourRequest = axios.CancelToken.source();
    const fetchData = async () => {
      const header = {headers: {language: context.locale}};
      const getData = await axios.get("static/about-jbfs-home", header, {
        cancelToken: ourRequest.token,
      });
      const get_brands_logo = await axios.get("top_product_brands", header, {
        cancelToken: ourRequest.token,
      });
      const get_public_settings = await axios.get("setting", header, {
        cancelToken: ourRequest.token,
      });
      setState({
        about: getData.data,
        product_brands: get_brands_logo.data.top_product_brands,
      });
      setSettings(get_public_settings.data);
      setSubject(
        context && context.locale === LANG_EN
          ? options[0].displayValue
          : optionsId[0].displayValue
      );
    };
    try {
      fetchData();
      loadDocumentTitle();
      setMessage(
        context.locale === LANG_EN
          ? defaultMessage[0].display
          : defaultMessage[0].displayId
      );
      // load recaptcha v3 script
      const siteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY;
      if (siteKey && !document.querySelector('script[data-jbfs-recaptcha]')) {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        script.defer = true;
        script.setAttribute('data-jbfs-recaptcha', 'true');
        document.body.appendChild(script);
      }
    } catch (e) {
      //
    }

    return () => {
      ourRequest.cancel();
    };

    //eslint-disable-next-line
  }, [context.locale]);

  useEffect(() => {
    //====================================================================
    // console.log('USE EFFECT 2 Send Message');
    //====================================================================

    const ourRequest = axios.CancelToken.source();
    const doSend = async () => {
      const data = {
        name,
        phone_number: phoneNumber,
        email,
        subject,
        message,
        'g-recaptcha-response': recaptchaToken || '',
      };
      await axios.post("contact_us", data);
      props.history.replace("/thanks-page");
    };
    if (isReadyToSend) {
      // console.log('isReadyToSend');
      doSend();
    }

    return () => {
      ourRequest.cancel();
    };

    //eslint-disable-next-line
  }, [isReadyToSend, context.locale]);

  const onChangeHandler = (event) => {
    const pattern = new RegExp(/[^\d]/g);
    const fieldName = event.target.name;
    if (fieldName === "name") {
      setName(event.target.value);
      if (event.target.value.trim().length < 1) {
        setState({ ...state, hasErrorname: true });
      } else if (event.target.value.length > 0) {
        setState({ ...state, hasErrorname: false });
      }
    }
    if (fieldName === "phone_number") {
      setPhoneNumber(event.target.value);
      if (event.target.value.trim().length < 1) {
        setState({
          ...state,
          hasErrorphone_number: true,
          hasErrorphone_numberFormat: false,
        });
      } else if (event.target.value.length > 0) {
        if (pattern.test(event.target.value)) {
          setState({
            ...state,
            hasErrorphone_number: false,
            hasErrorphone_numberFormat: true,
          });
        } else {
          setState({
            ...state,
            hasErrorphone_number: false,
            hasErrorphone_numberFormat: false,
          });
        }
      }
    }

    if (fieldName === "subject") {
      const datas = context.locale === LANG_EN ? [...options] : [...optionsId];
      const selectedSubject = datas.filter(
        (x) => x.value === event.target.value
      )[0];
      setSubject(selectedSubject.displayValue);
    }

    if (fieldName === "message") {
      setMessage(event.target.value);
      if (event.target.value.trim().length < 1) {
        //required taking out
        setState({ ...state, hasErrormessage: false });
      } else if (event.target.value.length > 0) {
        setState({ ...state, hasErrormessage: false });
      }
    }
  };

  const onSubmitHandler = () => {
    if (name === "") {
      setState({ ...state, hasErrorname: true });
      return;
    }
    if (phoneNumber === "") {
      setState({ ...state, hasErrorphone_number: true });
      return;
    }
    if (email === "") {
      setState({ ...state, hasErroremail: true });
      return;
    }
    if (message === "") {
      setState({ ...state, hasErrormessage: false });
      return;
    }

    const siteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY;
    if (!window.grecaptcha) {
      toast("Captcha not loaded, please try again later");
      return;
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(siteKey, { action: "contact_us" })
        .then((token) => {
          setRecaptchaToken(token);
          setIsVerified(true);
          if (
            !state.hasErroremail &&
            !state.hasErroremailFormat &&
            !state.hasErrorname &&
            !state.hasErrorphone_number &&
            !state.hasErroremail &&
            !state.hasErrormessage
          ) {
            toast("Submitting your message...");
            setIsReadyToSend(true);
            gaTracker(paramSubmitCategory, paramSubmitAction, paramSubmitLabel);
          }
        })
        .catch(() => toast("Captcha verification failed"));
    });
  };

  const emailInputHandler = (event) => {
    const email = event.target.value;
    const pattern = new RegExp(REGEX_EMAIL_PATTERN);

    setEmail(email);

    if (event.target.value.trim().length < 1) {
      setState({ ...state, hasErroremail: true, hasErroremailFormat: false });
    } else if (event.target.value.length > 0) {
      setState({ ...state, hasErroremailFormat: false });
      if (pattern.test(email)) {
        setState({
          ...state,
          isValidemail: true,
          hasErroremail: false,
          hasErroremailFormat: false,
        });
      } else {
        setState({
          ...state,
          isValidemail: false,
          hasErroremail: false,
          hasErroremailFormat: true,
        });
      }
    }
  };

  // const sendEmailHandler = () => {
  //
  //     const ourRequest = axios.CancelToken.source();
  //     const reqToken = new FormData();
  //     axios.post('contact_us', data, {}).then(response => {
  //         const config = {headers: {"Authorization": `Bearer ${response.data.access_token}`}}
  //         //==========================================================
  //         const data = new FormData();
  //         data.append('name', name);
  //         data.append('phone_number', phoneNumber);
  //         data.append('email', email);
  //         data.append('subject', subjectDesc);
  //         data.append('message', message);
  //         axios.post('contact_us', data, config)
  //             .then(() => {
  //                 props.history.replace('/thanks-page')
  //             }).catch(error => {
  //             //console.log(error);
  //         })
  //
  //     }).catch(error => {
  //         //
  //     });
  // }

  // reCAPTCHA v3: token will be retrieved on submit via grecaptcha.execute

  // let brands;
  // if (state.product_brands.length > 0) {
  //     brands = state.product_brands.map(brand => {
  //         return (
  //             // <React.Suspense fallback={'Load'}>
  //             //     <BrandCard brand={brand} classes={classes}/>
  //             // </React.Suspense>
  //         <BrandCard key={brand.id} brand={brand} classes={classes}/>
  //         )
  //     })
  // }

  const datas = context.locale === LANG_EN ? [...options] : [...optionsId];
  const listOptions = datas.map((opsi) => {
    return (
      <option key={opsi.value} value={opsi.value}>
        {opsi.displayValue}
      </option>
    );
  });

  return (
    <>
      <div
        className={["violet ", classes.AboutPage_container].join(" ")}
        ref={(section) => {
          scrollToComponent.Violet = section;
        }}
      >
        <Helmet>
          <meta
            name="description"
            content="JAPFA FOOD: As part of JAPFA group, an expert in the food industry for 50 years, JBFS was established to be the central sales and marketing support of japfa products."
          />
          <meta
            name="keywords"
            content="JAPFA Indonesia, food service, frozen food, supplier frozen food, Best Chicken, Tokusen, Omayo, Greenfields, so good, food catering, food service delivery, meat shop, Chicken shop, food solutions, JBFS, Food Supplier"
          />
          <meta name="author" content="" />
          <meta
            property="og:title"
            content="About Japfa Food | Indonesia | Food Supplier"
          />
          <meta
            property="og:description"
            content="JAPFA FOOD: As part of JAPFA group, an expert in the food industry for 50 years, JBFS was established to be the central sales and marketing support of japfa products."
          />
          <meta
            property="og:site_name"
            content="www.japfabestfoodsolutions.com"
          />
          <title>
            {localStorage.getItem("selected_page_title") &&
              `${localStorage.getItem(
                "selected_page_title"
              )}${" Japfa Food | Indonesia | Food Supplier"}`}
          </title>

          <link
            rel="canonical"
            href={window.location.origin.toString() + props.location.pathname}
          />
        </Helmet>
        <section
          className={["", classes.About_sections, classes.Even_section].join(
            " "
          )}
        >
          <div className={["jbfs-wrapper", classes.About_wrapper].join(" ")}>
            {/*Breadcrum region*/}
            <div className={["jbfs-breadcrumb-row"].join(" ")}>
              <HomeBreadcrumb />
              <span>/</span>
              <div>
                <FormattedMessage
                  id={"about.title"}
                  defaultMessage={"About JBFS"}
                />
              </div>
            </div>
            {/*Breadcrum region*/}
          </div>
        </section>

        <section
          className={[
            classes.About_sections,
            classes.Even_section,
            classes.HeaderSection_background,
          ].join(" ")}
        >
          <div
            className={[
              "jbfs-wrapper",
              classes.About_wrapper,
              classes.Header_wrapper,
            ].join(" ")}
          >
            <HeaderHero />
          </div>
        </section>

        <section className={[classes.About_sections].join(" ")}>
          <div
            className={[
              "jbfs-wrapper ",
              classes.About_wrapper,
              classes.Why_wrapper,
            ].join(" ")}
          >
            <h1 className={"jbfs-title-case"}>
              <FormattedMessage
                id={"about.why.title"}
                defaultMessage={"WHY?"}
              />
            </h1>
            <h2>
              <FormattedMessage
                id={"about.why.jbfs"}
                defaultMessage={"JAPFA FOOD"}
              />
            </h2>
            <div
              className={["jbfs-description", classes.Why_description].join(
                " "
              )}
            >
              {state.about && state.about.length < 1 ? (
                <h4>Loading...</h4>
              ) : (
                <p dangerouslySetInnerHTML={{ __html: state.about.content }} />
              )}
            </div>
            <img
              className={""}
              src={require("./assets/why-jbfs.svg")}
              alt={
                "About Japfa Food | Indonesia | Food Supplier"
              }
            />
          </div>
        </section>

        <section
          className={[classes.About_sections, classes.Even_section].join(" ")}
        >
          <div
            className={[
              "jbfs-wrapper",
              classes.About_wrapper,
              classes.Brands_wrapper,
            ].join(" ")}
          >
            <h2 className={"jbfs-title-case"}>
              <FormattedMessage
                id={"about.japfabrands.title"}
                defaultMessage={"JAPFA BRANDS"}
              />
            </h2>
            <div className={classes.Brands_row}>
              <div>
                {state.product_brands &&
                  state.product_brands.map((brand, index) => {
                    return (
                      <BrandCard
                        key={`${brand.id}${index}`}
                        brand={brand}
                        classes={classes}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </section>

        <section className={[classes.About_sections].join(" ")}>
          <div
            className={[
              "jbfs-wrapper",
              classes.About_wrapper,
              classes.ContactUs_wrapper,
            ].join(" ")}
          >
            <div className={["", classes.Cus_left].join(" ")}>
              <img
                className={classes.Cus_illustration}
                src={require("./assets/contact_us.svg")}
                alt={"contact us illustration"}
              />
              <h2>
                <FormattedMessage
                  id={"about.contactus.title"}
                  defaultMessage={"Contact Us"}
                />
              </h2>
              <div
                style={{ fontWeight: "bolder" }}
                className={["jbfs-description", classes.Cus_description].join(
                  " "
                )}
              >
                <p>
                  <FormattedMessage
                    id={"about.contactus.text"}
                    defaultMessage={
                      "Please reach out to us with your business needs our team is ready to help you with our wide range of protein solutions"
                    }
                  />
                </p>
              </div>
              <div className={classes.Cus_sosmed}>
                <ul className={classes.AppFooter_sosmedContainer}>
                  <li>
                    <a
                      href={
                        settings.instagram
                          ? "//" +
                            settings.instagram.replace(/(^\w+:|^)\/\//, "")
                          : ""
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={require("../../assets/sosmed/ico-ig-green.png")}
                        alt="Japfa Food Instagram"
                      />
                      &nbsp;@japfafood
                    </a>
                  </li>
                  {/*<li><a href={process.env.REACT_APP_JBFS_YT} target="_blank" rel="noopener noreferrer"><img src={require('../../assets/sosmed/o-yt.png')} alt="Jbfs Youtube"/></a></li>*/}
                </ul>
              </div>
            </div>
            <div className={["", classes.Cus_right].join(" ")}>
              <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              <div style={{ position: "relative" }}>
                {state.hasErrorname && (
                  <div className={classes.FormValidation_input}>
                    <FormattedMessage
                      id={"global.validation.required"}
                      defaultMessage={"Field is required !"}
                    />
                  </div>
                )}
                <Input
                  inputtype="input"
                  type="text"
                  name="name"
                  maxLength={30}
                  label={
                    <FormattedMessage
                      id={"global.formcontactus.name"}
                      defaultMessage={"Name"}
                    />
                  }
                  onChange={(event) => onChangeHandler(event)}
                  onFocus={(event) => onChangeHandler(event)}
                  value={name}
                />
              </div>
              <div className={classes.Group_contact}>
                <div>
                  {state.hasErrorphone_number && (
                    <div className={classes.FormValidation_input}>
                      <FormattedMessage
                        id={"global.validation.required"}
                        defaultMessage={"Field is required !"}
                      />
                    </div>
                  )}
                  {state.hasErrorphone_numberFormat && (
                    <div className={classes.FormValidation_input}>
                      <FormattedMessage
                        id={"global.validation.numberformat"}
                        defaultMessage={"Number format doesn't match !"}
                      />
                    </div>
                  )}
                  <Input
                    inputtype="input"
                    type="text"
                    name="phone_number"
                    label={
                      <FormattedMessage
                        id={"global.formcontactus.phonenumber"}
                        defaultMessage={"Phone Number"}
                      />
                    }
                    onChange={(event) => onChangeHandler(event)}
                    onFocus={(event) => onChangeHandler(event)}
                    value={phoneNumber}
                  />
                </div>
                <div>
                  {state.hasErroremail && (
                    <div className={classes.FormValidation_input}>
                      <FormattedMessage
                        id={"global.validation.required"}
                        defaultMessage={"Field is required !"}
                      />
                    </div>
                  )}
                  {state.hasErroremailFormat && (
                    <div className={classes.FormValidation_input}>
                      <FormattedMessage
                        id={"global.validation.emailformat"}
                        defaultMessage={"Email format doesn't match !"}
                      />
                    </div>
                  )}
                  <Input
                    inputtype="input"
                    type="text"
                    name="email"
                    label={
                      <FormattedMessage
                        id={"global.formcontactus.email"}
                        defaultMessage={"Email"}
                      />
                    }
                    onChange={(event) => emailInputHandler(event)}
                    onFocus={(event) => emailInputHandler(event)}
                    value={email}
                  />
                </div>
                {/*<span>{state.isValid ? ' valid email' : 'wrong email'}</span>*/}
              </div>
              <React.Fragment>
                {/*<Input inputtype="select" type="text" name="subject" label={<FormattedMessage id={"global.formcontactus.subject"} defaultMessage={"Subject"}/>}*/}
                {/*       elementconfig={context.locale === LANG_EN ? options : optionsId}*/}
                {/*       selectedvalue={options}*/}
                {/*       onChange={(event) => onChangeHandler(event)}*/}
                {/*       onFocus={(event) => onChangeHandler(event)}*/}
                {/*    // value={options}*/}
                {/*/>*/}
                <label htmlFor="opsi" className={classInput.Label}>
                  <FormattedMessage
                    id={"global.formcontactus.subject"}
                    defaultMessage={"Subject"}
                  />
                </label>
                <select
                  className={classInput.InputSelect}
                  name="subject"
                  id="opsi"
                  defaultValue={options[0].displayValue}
                  onChange={(e) => onChangeHandler(e)}
                  value={options.value}
                >
                  {listOptions}
                </select>
              </React.Fragment>
              <div style={{ position: "relative" }}>
                {state.hasErrormessage && (
                  <div className={classes.FormValidation_input}>
                    <FormattedMessage
                      id={"global.validation.required"}
                      defaultMessage={"Field is required !"}
                    />
                  </div>
                )}
                <Input
                  inputtype="textarea"
                  type="text"
                  name="message"
                  label={
                    <FormattedMessage
                      id={"global.formcontactus.message"}
                      defaultMessage={"Message"}
                    />
                  }
                  onChange={(event) => onChangeHandler(event)}
                  onFocus={(event) => onChangeHandler(event)}
                  value={message.replace(/(<([^>]+)>)/gi, "")}
                />
              </div>
              <div className={"jbfs-recaptcha"} />
              <div>
                <Button
                  className={classes.Button_send}
                  label={
                    <FormattedMessage
                      id={"global.formcontactus.button"}
                      defaultMessage={"Send"}
                    />
                  }
                  width={30}
                  onClick={() => onSubmitHandler()}
                />
              </div>
            </div>
          </div>
        </section>

        <div className={["jbfs-arrow-top"].join(" ")}>
          <JIcon
            icontype={"link_to_top"}
            onClick={() =>
              scrollToComponent(scrollToComponent.Violet, {
                offset: -99,
                align: "top",
                duration: 1500,
              })
            }
          />
        </div>
      </div>
    </>
  );
};

export default AboutHook;
